module.exports = __webpack_public_path__ + "static/media/perfil_bahia.9aad8bdb.jpg";